<template>
  <a
    v-if="elementType === 'link'"
    class="cf-link"
    :href="`tel:${ phoneNumber }`"
  >
    <div class="cf-flex cf-flex--row cf-flex--align-end cf-flex--gap-10">
      <span class="cf-icon far fa-phone" />

      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--black">
        {{ $phone(phoneNumber) }}
      </p>
    </div>
  </a>

  <button
    v-else
    type="button"
    class="cf-button cf-button--tertiary"
  >
    <div class="cf-flex cf-flex--row cf-flex--align-end cf-flex--gap-10">
      <span class="cf-icon far fa-phone" />

      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--black">
        {{ $phone(phoneNumber) }}
      </p>
    </div>
  </button>
</template>


<script>
  export default {
    name: 'CfStorePhoneNumber',

    props: {
      phoneNumber: {
        type: String,
        required: true
      },

      elementType: {
        type: String,
        default: 'button'
      }
    }
  };
</script>
